module.exports = __webpack_public_path__ + "static/media/anc6kz.928997c3.pdf";